import { Container } from 'ui/container'
import { Navigation } from 'features/admin/navigation'
import { useAdminCheck } from 'core/hooks/useAdminCheck'
import { Navigate } from 'react-router-dom'
import { routes } from 'core/routes/paths'

import c from './assets/sass/page.module.scss'

const AdminPage = () => {
    const { isAdmin, checking } = useAdminCheck()

    if (checking) {
        return (
            <div className={c.component}>
                <Container>
                    <div style={{ textAlign: 'center', padding: '40px 0' }}>
                        Проверка прав...
                    </div>
                </Container>
            </div>
        )
    }

    if (!isAdmin) {
        return <Navigate to={routes.main} replace />
    }

    return (
        <div className={c.component}>
            <div className={c.title}>
                <span>Админ-панель</span>
            </div>
            <Container>
                <Navigation />
            </Container>
        </div>
    )
}

export default AdminPage
